module.exports = __webpack_public_path__ + "img/1F1F4-1F1F2.d85c4413.svg";